import { render, staticRenderFns } from "./PmauSurvey.vue?vue&type=template&id=547cf281&"
import script from "./PmauSurvey.vue?vue&type=script&lang=js&"
export * from "./PmauSurvey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports